import { ZipCodeTestIds } from '@ui/business-components/ZipCodeForm/ZipCodeForm'

export const HOLIDAY_DATES = [
  '2021-07-05T00:00:00.000Z',
  '2021-09-06T00:00:00.000Z',
  '2021-10-11T00:00:00.000Z',
  '2021-11-11T00:00:00.000Z',
  '2021-11-24T00:00:00.000Z',
  '2021-12-25T00:00:00.000Z'
]

export const EST_TIME_ZONE = 'America/New_York'

export const TIME_SLOTS_TABLE_DAYS_QUANTITY = 5

export const DATE_FORMAT_TODAY_HEADING_CELL = 'MMM d'

export const DATE_FORMAT_OTHER_HEADING_CELLS = 'EEE, MMM d'

export const DATE_FORMAT_CONFIRMATION = 'MMM d'

export const TIME_FORMAT_CONFIRMATION = 'h:mm a'

export const DATE_FORMAT_CALENDAR = "yyyy-MM-dd'T'HH:mm:ssxxxxx"

export const ERROR_MESSAGES = {
  backgroundRequest: 'Sorry, there’s an error. Please refresh the page.',
  createLead: 'Sorry, there’s an error. Please submit your info again.',
  confirmBooking: 'Sorry, there’s an error. Please try again.'
}

export const LOCATION_FILTER_AB_TEST_VARIANTS = {
  control: 'Control',
  test: 'Test'
}

export const ZIP_CODE_FORM_TEST_IDS: ZipCodeTestIds = {
  form: 'booking-zip-code-form',
  input: 'booking-zip-code-input',
  button: 'booking-zip-code-button'
}

export const PROVIDER_SCREEN_BUTTONS_TITLES = {
  continue: 'continue',
  skip: 'skip'
}
